module.exports = new __parcel__URL__("soleil-nuage-1.555b937b.svg").toString();